import { observer } from 'mobx-react';
import Picker from '../Picker/Picker';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types/index';
import { getTranslate } from '~/utils/helpers';
import itemsStore from '~/view/screens/MenuManagementScreen/screens/ItemsScreen/store/itemsStore';
import './style.scss';
import { localeStore } from '~/mobx/localesStore';

interface IProps {
  itemId: number;
  modifierId: number;
  onSelect: (options: IPickerOption[]) => void;
}

export const ModifierPicker = (props: IProps): JSX.Element | null => {
  if (props.modifierId === 0) {
    return null;
  }

  const options = (): IPickerOption[] => {
    if (!itemsStore.item?.id) {
      return [];
    }

    return itemsStore.item?.modifiers.map((modifier) => {
      return {
        label: getTranslate(modifier.name),
        value: modifier.id,
      };
    });
  };

  const selectedOptions = (): IPickerOption[] => {
    if (!props.modifierId) {
      return [];
    }

    const modifier = itemsStore.item?.modifiers.find((modifier) => modifier.id === props.modifierId);

    if (modifier === undefined) {
      return [];
    }

    return [{ label: getTranslate(modifier.name), value: modifier.id }];
  };

  const selectModifiers = (options: IPickerOption[]) => {
    props.onSelect(options);
  };

  return (
    <Picker
      placeholder={localeStore.t('no_options')}
      key="modifiers-select"
      options={options()}
      selectedOptions={selectedOptions()}
      onSelect={selectModifiers}
      hideResetIcon
      searchable
      className="mr-2 pb-2 modifiers-select"
    />
  );
};

export default observer(ModifierPicker);
